/**
  * @name APP u-Planning
  * @autor over.martinez@u-planner.com
  * @description
  * Descripcion del controlador
  * @controller 
  * # name: ScheduleListCtrl
  * # alias: schedulesListVm
  */
  
export default class ScheduleListCtrl {
  
	constructor ($scope, WorkPlanSrv, $interval, $mdDialog, $stateParams, $cookies, GlobalConfig, WorkPlanModalSrv, $sessionStorage) {
		this.luser = JSON.parse($cookies.get('currentUser'))
		this.SEARCH_PARAMS = {
			teacherId : this.luser.teacherId,
			workplanId: this.luser.workplanId,
		}
		// declaracion de variables
		this.$scope = $scope
		this.regex = /^(([01]?[0-9]|2[0-3]):[0-5][0-9])|(([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])$/
		this.daysArray = []
		this.isTouchedDays = false
		this.$sessionStorage = $sessionStorage
		this.WorkPlanSrv = WorkPlanSrv
		this.GlobalConfig = GlobalConfig
		this.configScheduleTypeId = this.GlobalConfig.scheduleTypeId
		this.WorkPlanModalSrv = WorkPlanModalSrv
		this.$mdDialog = $mdDialog
		this.workPlanGeneralList = $sessionStorage.workPlanGeneralList
		this.selectedDays = {}
		this.periodsArray = []
		this.typePeriod = []
		this.isTouchedPeriods = false
		this.selectedTypePeriod = {}
		this.scheduleTypeId = this.configScheduleTypeId.presencial
		this.scheduleRadio = 'Atención virtual'
		this.editOrCreated = 'Creación exitosa' 
		this.actionEditOrCreate = 'creado'
		this.invalidMinHour = false
		this.feedback = 0
		this.planningFinish = true
		this.isSaveButtonDisabled = false
		this.hourPlanningRequired = false
		this.mostrarObsAdicionalesOblig = true
		// sustituir por valores que deberian estar en log de usuario
		// y JSON traido de la seccion docencia
		this.activityId = 34
		this.gridApi = {}
		this.calendarId = null
		this.workplanTeacherActivityId = null
		this.startHour = null
		this.endHour = null
		this.description = null
		this.editing = false
		this.showTable = true
		this.isFeedback = JSON.parse($cookies.get('currentUser')).isFeedback
		this.iconClasses = [
			'mdi-hardware-keyboard-arrow-down',
			'mdi-hardware-keyboard-arrow-up',
		]
		this.class = this.iconClasses[1]
		this.calendarIdForVirtualAttention = null
		this.workplanTeacherActivityIdForVirtualAttention = null

		this.gridListSchedules = {
			enableFiltering          : false,
			enableVerticalScrollbar  : 1,
			enableHorizontalScrollbar: 0,
			columnDefs               : [
				{
					name            : 'Período',
					displayName     : 'Período',
					field           : 'periodsNames',
					width           : '25%',          
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs p-b-sm',
				}, {
					name            : 'Día',
					displayName     : 'Día',
					field           : 'daysNames',
					width           : '30%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs p-b-sm',
				}, {
					name            : 'Horario',
					displayName     : 'Horario',
					width           : '25%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs p-b-sm',
					cellTemplate    : require('./cellSchedule.html'),
				}, {
					name            : 'Acciones',
					displayName     : 'Acciones',
					width           : '20%',
					enableGridMenu  : false,
					enableFiltering : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'column-center text-xs',
					headerCellClass : 'column-center font-normal text-xs p-b-sm',
					cellTemplate    : require('./cellScheduleActions.html'),
				},
			],
			onRegisterApi: (gridApi) => {
				this.gridApi = gridApi
				$interval(() => {
					this.gridApi.core.handleWindowResize()
				}, 200, 10)
			},
		}
  
		/**************************************
      * funcion inicial                   *
      ***************************************/
		this.activate()
	}

	activate () {
		this.getDaysAndPeriodsData()

		if (this.workPlanGeneralList != undefined) {
			this.status = this.workPlanGeneralList.wokplanTeacherStatus[0]
			this.stages = this.workPlanGeneralList.stages
			this.feedback = this.status.feedbackReviewed
			this.isPlanning(this.status, this.stages)
    
			if (this.feedback && !this.planningFinish) {
				this.getSchedulesRejectData()
			} else {
				this.getSchedulesData()
			}
		} else {
			this.getGeneralsWorkplan().then((promise) => {
				if (this.feedback && !this.planningFinish) {
					this.getSchedulesRejectData()
				} else {
					this.getSchedulesData()
				}
			})
		}
	}

	getDaysAndPeriodsData () {
		this.WorkPlanSrv.getDataForSchedule.get(this.SEARCH_PARAMS).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.typePeriod = dataReturn.periods
				this.days = dataReturn.days
			} else {
			}
		}, (data) => {
			console.log(data)
		})
	}

	getGeneralsWorkplan () {
		return this.WorkPlanSrv.getElementsRightBar.getList({ teacherId: this.SEARCH_PARAMS.teacherId }).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.$sessionStorage.workPlanGeneralList = dataReturn.data
				this.status = dataReturn.data.wokplanTeacherStatus[0]
				this.stages = dataReturn.data.stages
				this.feedback = this.status.feedbackReviewed
				this.isPlanning(this.status, this.stages)
			} else {
				console.log('Comunications problem with the server')
			}
		}, (data) => {
			console.log(data)
		})
	}

	isPlanning (status, stages) {
		this.currentDate = moment(new Date()).format('DD/MM/YYYY')
		for (var i = stages.length - 1; i >= 0; i--) {
			if (stages[i].stageId == this.GlobalConfig.workplanIdStages.review) {
				this.startDateStage = stages[i].startDate
			}
		}

		if (status.workplanActive) {
			if (status.planningFinish == this.active) {
				this.planningFinish = true

				if (this.startDateReview < this.currentDate || status.reviewedFinish == this.active) {
					this.planningFinish = true
				} else if (status.reviewedReject == this.active) {
					this.planningFinish = false
				}
			} else {
				this.planningFinish = false
			}
		} else {
			this.planningFinish = true
		}
	}

	highlightFilteredHeader (row, rowRenderIndex, col, colRenderIndex) {
		if (col.filters[0].term) {
			return 'header-filtered'
		} else {
			return ''
		}
	}

	getSchedulesData () {
		this.WorkPlanSrv.getSchedules.getList(this.SEARCH_PARAMS).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.gridListSchedules.data = this.getPresentialInfo(dataReturn.data)
				this.virtualAttentionHours = this.getTotalVirtualAttentionInfo(dataReturn.data)
			} else {
				this.gridListSchedules.data = []
				this.virtualAttentionHours = 0
			}
		}, (data) => {
			console.log(data)
		})
	}

	getSchedulesRejectData () {
		this.WorkPlanSrv.getSchedulesReject.getList(this.SEARCH_PARAMS).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.gridListSchedules.data = this.getPresentialInfo(dataReturn.data)
				this.virtualAttentionHours = this.getTotalVirtualAttentionInfo(dataReturn.data)
			} else {
				this.gridListSchedules.data = []
				this.virtualAttentionHours = 0
			}
		}, (data) => {
			console.log(data)
		})
	}

	hiddenTable () {
		if (this.class === this.iconClasses[0]) {
			this.class = this.iconClasses[1]
			this.showTable = true
		} else {
			this.class = this.iconClasses[0]
			this.showTable = false
		}
	}

	hasError (input) {
		if (input && input.$invalid && (input.$dirty || input.$touched)) {
			return 'has-error'
		}
	}

	hasErrorEndHour (input) {
		if (input && input.$invalid && (input.$dirty || input.$touched) || (this.invalidMinHour)) {
			return 'has-error'
		}
	}

	showErrorMessages (input) {
		return input && (input.$dirty || input.$touched)
	}

	validateForm (form, virtualForm) {
		if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
			return form.$invalid ||
             this.validateCheklistDays() ||
             this.validateCheklistPeriods() ||
             this.invalidMinHour
		} else {
			return virtualForm.$invalid
		}
	}

	validateHour (input) {
		return input.$error.pattern
	}

	validateCheklistDays () {
		return this.scheduleTypeId == this.configScheduleTypeId.presencial && this.daysArray.length < 1
	}

	validateHours (inputStart, inputEnd) {
		if (!this.validateHour(inputStart) && !this.validateHour(inputEnd) && !inputStart.$invalid && !inputEnd.$invalid) {
			var splitStart = this.startHour.split(':')
			var splitEnd = this.endHour.split(':')

			if (parseInt(splitStart[0]) < parseInt(splitEnd[0])) {
				this.invalidMinHour = false

				return this.invalidMinHour
			}

			if (parseInt(splitStart[0]) === parseInt(splitEnd[0])) {
				if (parseInt(splitStart[1]) < parseInt(splitEnd[1])) {
					this.invalidMinHour = false

					return this.invalidMinHour
				}
			}

			this.invalidMinHour = true

			return this.invalidMinHour
		}
	}

	funSelectedDays (day, checked) {
		if (checked) {
			if (!this.daysArray.includes(day.dayId)) {
				this.daysArray.push(day.dayId)
			}
		} else {
			let index = this.daysArray.indexOf(day.dayId)

			if (index != -1) {
				this.daysArray.splice(index, 1)
			}
		}

		this.isTouchedDays = true
	}

	validateCheklistPeriods () {
		return this.scheduleTypeId == this.configScheduleTypeId.presencial && this.periodsArray.length < 1
	}

	funSelectedPeriod (period, checked) {
		if (checked) {
			if (!this.periodsArray.includes(period.periodId)) {
				this.periodsArray.push(period.periodId)
			}
		} else {
			let index = this.periodsArray.indexOf(period.periodId)

			if (index != -1) {
				this.periodsArray.splice(index, 1)
			}
		}

		this.isTouchedPeriods = true
	}

	addSchedule (form, virtualForm) {
		if (this.scheduleTypeId == this.configScheduleTypeId.presencial)
			this.createJson(form)
		else
			this.createJson(virtualForm)
	}

	createJson (form) {
		this.schedule = {
			teacherId         : this.SEARCH_PARAMS.teacherId,
			workplanId        : this.SEARCH_PARAMS.workplanId,
			activityId        : this.activityId,
			scheduleTypeId    : this.scheduleTypeId,
			description       : this.description,
			isFeedbackActivity: this.isFeedback,
		}

		//si es de tipo presencial, agregar los dias, periodos, hora de inicio/fin y descripcion
		if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
			this.scheduleRadio = 'Atención presencial'  

			var arrayPeriod = []

			for (var index in this.periodsArray) {
				var temp = {
					periodId: this.periodsArray[index],
				}

				arrayPeriod.push(temp)
			}

			var arrayDays = []

			for (var index in this.daysArray) {
				var temp = {
					dayId: this.daysArray[index],
				}

				arrayDays.push(temp)
			}

			this.schedule.days = arrayDays
			this.schedule.periods = arrayPeriod
			this.schedule.startHour = this.startHour
			this.schedule.endHour = this.endHour
		} else { // no es presencial, agregamos las horas
			this.schedule.hoursPlanning = this.hoursPlanning
		}

		if (this.editing || this.scheduleTypeId == this.configScheduleTypeId.virtual) {
			if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
				this.schedule.workplanTeacherActivityId = this.workplanTeacherActivityId
				this.schedule.calendarId = this.calendarId
			} else { // virtual
				this.schedule.workplanTeacherActivityId = this.workplanTeacherActivityIdForVirtualAttention
				this.schedule.calendarId = this.calendarIdForVirtualAttention
			}

			this.editExistingSchedule(this.schedule, form)
			this.editOrCreated = 'Edición exitosa'
		} else {
			if (this.isValidSchedule(this.schedule))
				this.addNewSchedule(this.schedule, form)
			else
				this.showModalScheduleFailure('Estas horas ya han sido seleccionadas en la semana')
		}
	}

	addNewSchedule (schedule, form) {
		this.isSaveButtonDisabled = true
		this.WorkPlanSrv.addSchedule.add(schedule).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.showModalScheduleSuccess()

				if (this.feedback && !this.planningFinish)
					this.getSchedulesRejectData()
				else
					this.getSchedulesData()

				this.gridApi.grid.refresh()
				this.cleanForm(form)
			} else {
				this.isSaveButtonDisabled = false
				this.showModalScheduleFailure('Ha ocurrido un problema de conexión con el servidor')
			}
		}, (data) => {
			this.isSaveButtonDisabled = false
			console.log(data)
		})
	}

	editExistingSchedule (schedule, form) {
		this.isSaveButtonDisabled = true
		this.WorkPlanSrv.updateSchedule.update(schedule).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.showModalScheduleSuccess()

				if (this.feedback && !this.planningFinish)
					this.getSchedulesRejectData()
				else
					this.getSchedulesData()

				this.gridApi.grid.refresh()
				this.cleanForm(form)
				this.editing = false
			} else {
				this.isSaveButtonDisabled = false
				this.showModalScheduleFailure('Ha ocurrido un problema de conexión con el servidor')
			}
		}, (data) => {
			this.isSaveButtonDisabled = false
			console.log(data)
		})
	}

	cleanForm (form) {
		this.daysArray = []
		this.selectedDays = {}
		this.periodsArray = []
		this.selectedTypePeriod = {}
		this.startHour = null
		this.endHour = null
		this.description = null
		this.isTouchedPeriods = false
		this.isTouchedDays = false
		this.scheduleTypeId = 1
		this.mostrarObsAdicionalesOblig = false
		this.calendarId = null
		this.workplanTeacherActivityId = null
		this.editing = false
		this.hoursPlanning = null
		this.isSaveButtonDisabled = false
		form.$setPristine()
		form.$setUntouched()
	}

	setValues (schedule) {
		this.calendarId = schedule[0].calendarId
		this.workplanTeacherActivityId = schedule[0].workplanTeacherActivityId
		this.scheduleTypeId = schedule[0].scheduleTypeId
		this.startHour = schedule[0].startHour
		this.endHour = schedule[0].endHour
		this.description = schedule[0].description

		this.daysArray = []
		this.selectedDays = {}
		this.periodsArray = []
		this.selectedTypePeriod = {}
		this.hoursPlanning = schedule[0].hoursPlanned

		//si es de tipo presencial, setear los dias y periodos
		if (this.scheduleTypeId == this.configScheduleTypeId.presencial) {
			var splits = schedule[0].daysId.split(',')

			for (var i = 0; i < splits.length; i++) {
				var valor = splits[i]

				this.daysArray.push(parseInt(valor))
				this.selectedDays[valor] = true
			}
			splits = schedule[0].periodsId.split(',')
			for (var i = 0; i < splits.length; i++) {
				var valor = splits[i]

				this.periodsArray.push(parseInt(valor))
				this.selectedTypePeriod[valor] = true
			}
		}
  
		this.editing = true
	}

	getSchedule (schedule) {
		this.actionEditOrCreate = 'modificado'
		let header = {
			calendarId: schedule.calendarId,
		}

		this.WorkPlanSrv.getScheduleById.get(header).$promise.then((dataReturn) => {
			if (dataReturn.status) {
				this.setValues(dataReturn.data)
			} else {

			}
		}, (data) => {
			console.log(data)
		})
	}
	/**************************************
      * aqui termina add/edit               *
      ***************************************/

	/**************************************
    * Aqui Comienza Delete Schedule       *
    ***************************************/
	confirmDisableSchedule (row) {
		let schedule = row

		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', 'WorkPlanSrv', function ($scope, $mdDialog, WorkPlanSrv) {
				let confirmDisableCtlVm = this

				confirmDisableCtlVm.schedule = schedule

				confirmDisableCtlVm.close = close
				confirmDisableCtlVm.disableSchedule = disableSchedule

				function close () {
					$mdDialog.hide()
				}

				function disableSchedule () {
					WorkPlanSrv.disableSchedule.disable({
						calendarId               : confirmDisableCtlVm.schedule.calendarId,
						workplanTeacherActivityId: confirmDisableCtlVm.schedule.workplanTeacherActivityId,
					}).$promise.then((dataReturn) => {
						$mdDialog.hide(dataReturn) 
					})
				}
			} ],
			controllerAs       : 'confirmDisableCtlVm',
			template           : require('./disableScheduleModal.html'),
			clickOutsideToClose: false,
		})
			.then((dataReturn) => {
				if (dataReturn && dataReturn.status) {
					if (this.feedback && !this.planningFinish)
						this.getSchedulesRejectData()
					else
						this.getSchedulesData()

					this.gridApi.grid.refresh()
					this.showModalDeleteSuccess()
				}
			})
	}

	showModalDeleteSuccess () {
		let texts = this.GlobalConfig.appTexts
		let header = {
			createOrEdit    : texts.deleteDialog,
			textCreateOrEdit: texts.deleted,
			itemName        : 'el horario seleccionado',
			nameModal       : texts.modalTypeName.deleted,
			modalType       : texts.modalTypeId.default,
		}

		this.WorkPlanModalSrv.setVariableSuccessDialog(header)
		this.WorkPlanModalSrv.successDialog(header)
	}
	/**************************************
      * Aqui Termina Delete Schedule        *
      ***************************************/

	/**************************************
    * Modal para add/edit exitoso         *
    ***************************************/
	showModalScheduleSuccess () {
		let texts = this.GlobalConfig.appTexts
		let createdOrEdit = texts.saved
		let successAction = texts.createDialog

		if (this.editing) {
			createdOrEdit = texts.modified
			successAction = texts.editDialog
		}

		let header = {
			createOrEdit    : successAction,
			textCreateOrEdit: createdOrEdit,
			itemName        : this.scheduleRadio,
			nameModal       : texts.modalTypeName.schedule,
			modalType       : texts.modalTypeId.default,
		}

		this.WorkPlanModalSrv.setVariableSuccessDialog(header)
		this.WorkPlanModalSrv.successDialog(header)
	}

	/**************************************
    * Modal para add/edit fallo           *
    ***************************************/
	showModalScheduleFailure (text) {
		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
				var failureDialogCtlVm = this

				failureDialogCtlVm.text = text
				failureDialogCtlVm.close = function () {
					$mdDialog.hide()
				}
			} ],
			template           : require('./failureScheduleModal.html'),
			controllerAs       : 'failureDialogCtlVm',
			clickOutsideToClose: true,
		})
	}

	cambiarVistaObsAdic (val) {
		if (val === 1) {
			this.mostrarObsAdicionalesOblig = true
			this.hourPlanningRequired = false
		} else if (val === 2) {
			this.mostrarObsAdicionalesOblig = false
			this.hourPlanningRequired = true
		}
	}

	getPresentialInfo (data) {
		var result = []

		data.forEach((element) => {
			if (element.scheduleTypeId == this.configScheduleTypeId.presencial)
				result.push(element)
		})

		return result
	}

	getTotalVirtualAttentionInfo(data) {
		var result = 0

		data.forEach((element) => {
			if (element.scheduleTypeId == this.configScheduleTypeId.virtual) {
				let hours = element.hoursPlanned | 0

				result = result + hours
				this.calendarIdForVirtualAttention = element.calendarId
				this.workplanTeacherActivityIdForVirtualAttention = element.workplanTeacherActivityId
			}
		})

		return result
	}

	isValidSchedule (schedule) {
		let isValid = true

		schedule.startHour = schedule.startHour + ':00'
		schedule.endHour = schedule.endHour + ':00'
		for (var idx1 in this.gridListSchedules.data) {
			var element = this.gridListSchedules.data[idx1]

			for (var idx2 in schedule.days) {
				var day = schedule.days[idx2]

				if (parseInt(day.dayId) === parseInt(element.daysId)) {
					let scheduleStartHour = moment(schedule.startHour, 'HH:mm:ss').toDate()
					let scheduleEndHour = moment(schedule.endHour, 'HH:mm:ss').toDate()
					let elementStartHour = moment(element.startHour, 'HH:mm:ss').toDate()
					let elementEndHour = moment(element.endHour, 'HH:mm:ss').toDate()

					if ((scheduleStartHour <= elementStartHour) && scheduleEndHour <= elementStartHour) {
						console.log('if')
						//isValid = true
					} else if (scheduleStartHour >= elementEndHour) {
						console.log('else if')
						//isValid = true
					} else {
						//console.log("else")
						isValid = false
						break
					}
				}
			}

			if (!isValid)
				break
		}

		return isValid
	}

}

ScheduleListCtrl.$inject = [ '$scope', 'WorkPlanSrv', '$interval', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', '$sessionStorage' ]


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/studentAttention/listSchedules/scheduleListCtrl.js